import React, { FC, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { styled } from 'linaria/react';
import { Otp } from '@widgets/otp';
import { TspPaymentStep } from '@entities/payment';
import { PaymentPayee, useCyberStore } from '@entities/tsp';
import { withTheme } from '@shared/lib/theme';
const DynamicAnimatedBackground = dynamic(() => import('@shared/ui/organisms').then(imported => imported.AnimatedBackground), {
  ssr: false
});
interface OtpPcekPageViewProps {
  showVouchersForm: boolean;
  payee: PaymentPayee;
}
const OtpPcekPageView: FC<OtpPcekPageViewProps> = ({
  showVouchersForm,
  payee
}) => {
  const {
    setStep
  } = useCyberStore();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return () => {
      setStep(TspPaymentStep.SERVICES_FORM);
    };
  }, [setStep]);
  return <OtpPcekPageViewWrapper>
      <NotScrollableContentWrapper>
        <DynamicAnimatedBackground />
      </NotScrollableContentWrapper>
      <ScrollableContentWrapper>
        <OtpWrapper>
          <Otp showVouchersForm={showVouchersForm} payee={payee} />
        </OtpWrapper>
      </ScrollableContentWrapper>
    </OtpPcekPageViewWrapper>;
};
export default OtpPcekPageView;
const OtpPcekPageViewWrapper = /*#__PURE__*/styled('div')({
  name: "OtpPcekPageViewWrapper",
  class: "o11zlbtc",
  propsAsIs: false
});
const NotScrollableContentWrapper = /*#__PURE__*/styled('div')({
  name: "NotScrollableContentWrapper",
  class: "n16s2kyv",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ScrollableContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ScrollableContentWrapper",
  class: "s4tvddt",
  propsAsIs: false,
  vars: {
    "s4tvddt-0": [_exp()]
  }
}));
const OtpWrapper = /*#__PURE__*/styled('div')({
  name: "OtpWrapper",
  class: "o3kg1j2",
  propsAsIs: false
});

require("./OtpPcekPageView.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OtpPcekPageView.tsx");